import React from 'react';
import { cn } from 'lib/utils';

interface ChipProps {
    label: string;
    active?: boolean;
    onClick?: () => void;
    icon?: React.ReactNode;
}

/**
 * 필터 칩. 공지사항 카테고리 칩과 동일 톤 — 활성 primary 면, 비활성 muted 면. 4px radius.
 */
const Chip: React.FC<ChipProps> = ({ label, active = false, onClick, icon }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-pressed={active}
            className={cn(
                'inline-flex h-8 items-center gap-1.5 rounded px-3 text-sm font-medium transition-colors duration-fast',
                active
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-neutral-700 hover:bg-accent hover:text-primary'
            )}
        >
            {icon && (
                <span className="inline-flex items-center justify-center [&_svg]:h-3 [&_svg]:w-3">
                    {icon}
                </span>
            )}
            <span>{label}</span>
        </button>
    );
};

interface ChipGroupProps {
    children: React.ReactNode;
    className?: string;
}

export const ChipGroup: React.FC<ChipGroupProps> = ({ children, className = '' }) => (
    <div className={cn('flex flex-wrap items-center gap-1', className)}>{children}</div>
);

export default Chip;
